import { render, staticRenderFns } from "./couponArea.vue?vue&type=template&id=124889b5&scoped=true&"
import script from "./couponArea.vue?vue&type=script&lang=js&"
export * from "./couponArea.vue?vue&type=script&lang=js&"
import style0 from "./couponArea.vue?vue&type=style&index=0&id=124889b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124889b5",
  null
  
)

export default component.exports